<section class="gmid-lookup">
    <!-- Search Card -->
    <div class="card m-b-20">
        <div class="card-header">
            <i class="fa fa-search label-icon" aria-hidden="true"></i>
            <label class="p-l-5 m-b-0">GMID Lookup</label>
        </div>
        <div class="card-body">
            <div class="row align-items-end">
                <div class="col-sm-5">
                    <label for="gmid-input">Enter GMID:</label>
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        [class.is-invalid]="errorMessage"
                        id="gmid-input"
                        [(ngModel)]="gmidInput"
                        placeholder="Enter GMID to search..."
                        (keyup.enter)="search()"
                    />
                    <small *ngIf="errorMessage" class="text-danger d-block m-t-5">
                        <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{errorMessage}}
                    </small>
                </div>
                <div class="col-sm-3 p-t-5">
                    <button class="btn btn-info btn-sm" type="button" (click)="search()" [disabled]="isLoading">
                        <i class="fa" [ngClass]="isLoading ? 'fa-spinner fa-spin' : 'fa-search'" aria-hidden="true"></i>
                        {{ isLoading ? 'Searching...' : 'Search' }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Loading Indicator -->
    <div *ngIf="isLoading" class="text-center m-t-30 m-b-30">
        <i class="fa fa-spinner fa-spin fa-2x text-muted"></i>
        <p class="text-muted m-t-10">Searching...</p>
    </div>

    <!-- No Results -->
    <div *ngIf="searchPerformed && !profitCenter && !isLoading" class="card">
        <div class="card-body text-center p-30">
            <i class="fa fa-search fa-2x text-muted"></i>
            <h5 class="text-muted m-t-10">No Profit Center found</h5>
            <p class="text-muted m-b-0">No results found for GMID: <strong>{{gmidInput}}</strong></p>
        </div>
    </div>

    <!-- Results -->
    <div *ngIf="profitCenter && !isLoading">
        <!-- Hierarchy Summary Row -->
        <div class="row top-stat m-b-20">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <i class="fa fa-briefcase label-icon label-head-icon" aria-hidden="true"></i>
                        <label class="p-l-5">Business:</label>
                        <label class="detail-label">{{businessInfo?.xName || '...'}}</label>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <i class="fa fa-link label-icon label-head-icon" aria-hidden="true"></i>
                        <label class="p-l-5">Chain:</label>
                        <label class="detail-label">{{chainInfo?.xName || (storeInfo?.xStructs?.xChainID ? '...' : 'N/A')}}</label>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <i class="fa fa-map-marker label-icon label-head-icon" aria-hidden="true"></i>
                        <label class="p-l-5">Store:</label>
                        <label class="detail-label">{{storeInfo?.xName || profitCenter?.xStoreName || '...'}}</label>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <i class="fa fa-building-o label-icon label-head-icon" aria-hidden="true"></i>
                        <label class="p-l-5">Profit Center:</label>
                        <label class="detail-label">{{profitCenter.xName}}</label>
                    </div>
                </div>
            </div>
        </div>

        <!-- Detail Cards -->
        <div class="row">
            <!-- Profit Center Details -->
            <div class="col-sm-8">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <span>
                            <i class="fa fa-building-o label-icon" aria-hidden="true"></i>
                            <label class="p-l-5 m-b-0">Profit Center Details</label>
                        </span>
                        <button class="btn btn-info btn-sm" type="button" (click)="navigateToProfitCenter()" [disabled]="profitCenter?.xStatus !== 1">
                            <i class="fa fa-external-link" aria-hidden="true"></i> Edit Profit Center
                        </button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">Name:</label>
                                    <p class="lookup-value">{{profitCenter.xName || '-'}}</p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">GMID:</label>
                                    <p class="lookup-value"><strong>{{profitCenter.xGMID || '-'}}</strong></p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">Profit Center Number:</label>
                                    <p class="lookup-value">{{profitCenter.xPCtrNum || '-'}}</p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">Short Code:</label>
                                    <p class="lookup-value">{{profitCenter.xShortCode || '-'}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">Status:</label>
                                    <p class="lookup-value">
                                        <span class="badge" [ngClass]="profitCenter.xStatus === 1 ? 'badge-success' : 'badge-danger'">
                                            {{profitCenter.xStatus === 1 ? 'Active' : 'Inactive'}}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">GMPW:</label>
                                    <p class="lookup-value">{{profitCenter.xGMPW || '-'}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label class="text-muted lookup-label">Notes:</label>
                                    <p class="lookup-value">{{profitCenter.xNotes || '-'}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group m-b-0">
                                    <label class="text-muted lookup-label">ID:</label>
                                    <p class="lookup-value text-muted small m-b-0">{{profitCenter._id || '-'}}</p>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>

            <!-- Right Column -->
            <div class="col-sm-4">
                <!-- Store Card -->
                <div class="card m-b-15">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <span>
                            <i class="fa fa-map-marker label-icon" aria-hidden="true"></i>
                            <label class="p-l-5 m-b-0">Store</label>
                        </span>
                        <button
                            class="btn btn-default btn-sm"
                            type="button"
                            (click)="navigateToStore()"
                            [disabled]="!profitCenter.xStoreID || storeInfo?.xStatus !== 1"
                            tooltip="Go to Store"
                            placement="left"
                            container="body"
                            containerClass="tooltip-global"
                        >
                            <i class="fa fa-external-link" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="card-body">
                        <p class="m-b-5"><span class="text-muted">Name: </span>{{storeInfo?.xName || profitCenter?.xStoreName || '-'}}</p>
                        <p *ngIf="storeInfo?.xStoreNum" class="m-b-5"><span class="text-muted">Store #: </span>{{storeInfo.xStoreNum}}</p>
                        <p class="text-muted small m-b-0">ID: {{profitCenter.xStoreID || '-'}}</p>
                    </div>
                </div>

                <!-- Chain Card -->
                <div class="card m-b-15">
                    <div class="card-header">
                        <i class="fa fa-link label-icon" aria-hidden="true"></i>
                        <label class="p-l-5 m-b-0">Chain</label>
                    </div>
                    <div class="card-body">
                        <div *ngIf="chainInfo">
                            <p class="m-b-5"><span class="text-muted">Name: </span>{{chainInfo.xName || '-'}}</p>
                            <p *ngIf="chainInfo.xStructNum" class="m-b-5"><span class="text-muted">Struct #: </span>{{chainInfo.xStructNum}}</p>
                            <p class="text-muted small m-b-0">ID: {{chainInfo._id || '-'}}</p>
                        </div>
                        <p *ngIf="!chainInfo" class="text-muted m-b-0">No chain information</p>
                    </div>
                </div>

                <!-- Business Card -->
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <span>
                            <i class="fa fa-briefcase label-icon" aria-hidden="true"></i>
                            <label class="p-l-5 m-b-0">Business</label>
                        </span>
                        <button
                            class="btn btn-default btn-sm"
                            type="button"
                            (click)="navigateToBusiness()"
                            [disabled]="!profitCenter.xBusinessID || businessInfo?.xStatus !== 1"
                            tooltip="Go to Business"
                            placement="left"
                            container="body"
                            containerClass="tooltip-global"
                        >
                            <i class="fa fa-external-link" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="card-body">
                        <div *ngIf="businessInfo">
                            <p class="m-b-5"><span class="text-muted">Name: </span>{{businessInfo.xName || '-'}}</p>
                            <p *ngIf="businessInfo.xBusinessNum" class="m-b-5"><span class="text-muted">Business #: </span>{{businessInfo.xBusinessNum}}</p>
                            <p class="text-muted small m-b-0">ID: {{profitCenter.xBusinessID || '-'}}</p>
                        </div>
                        <p *ngIf="!businessInfo" class="text-muted m-b-0">Loading...</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
